import Image from 'next/image'

export default function CircleCard({
  data
}) {

  return (
    <div className='flex justify-center group/card'>
      <a
        href={data.link}
        target="_blank"
      >
        <Image
          src={data.cover}
          width={75}
          height={75}
          alt={data.title}
          unoptimized
          className='w-75 h-75 shadow-card rounded-half block mx-auto group-hover/card:shadow-menu'
        />
        <div className='text-center mt-16'>{data.title}</div>
      </a>
    </div>
  )
}